import { GET } from './'

export const fetchICEServers = () => GET({ url: 'twilio/ice-connection' })
